<ng-container *transloco="let t; prefix: 'loan-wizard'">
    <ng-container *ngIf="resultData.isEligible">
        <div class="container pt-[4.5rem] pb-[96px]">
            <div class="flex lg:flex-row flex-col justify-between gap-12">
                <div class="max-w-[700px]">
                    <div class="mb-10">
                        <h3 class="text-black font-bold text-[2.5rem] mb-4">Καλά νέα</h3>
                        <p class="rfs:text-2xl mb-4">Από τα στοιχεία που μας έδωσες, φαίνεται πως πληροίς τις
                            προϋποθέσεις για τη χρηματοδότηση που σε ενδιαφέρει.</p>
                        <p>Αυτή είναι μια προκαταρκτική αξιολόγηση της δυνατότητάς σου να αποκτήσεις χρηματοδότηση. Δεν
                            αποτελεί επίσημη αίτηση ή δέσμευση για χορήγηση δανείου.</p>
                    </div>
                    @if (propertyId != undefined) {
                        <div class="mb-10">
                            <app-property-card-item [isClickable]="false" [withBorder]="false" [showFavorite]="false" [propertySummary]="propertyCardSummaryData"></app-property-card-item>
                        </div>
                    }
                    <div class="flex flex-wrap gap-6 mb-10 flex-wrap">
                        <button class="btn-primary w-full sm:w-auto" (click)="goToLoanApplication()">Εκδήλωσε ενδιαφέρον</button>
                        <button class="btn-secondary justify-center w-full sm:w-auto" (click)="onCalculateAgain()">Υπολόγισε ξανά</button>
                    </div>
                    <section #callback class="mt-8">
                      <app-experts-callback [property]="propertyCardSummaryData" [modalComponent]="'RequestCallbackModalComponent'"></app-experts-callback>
                    </section>
                </div>
                <div>
                    <app-doughnut-chart [showEstimatedFees]="false"></app-doughnut-chart>
                    <div class="my-6 text-gray-700 font-semibold flex flex-row justify-center gap-2 text-xs">
                        {{ "financing.calculator-section.fulfilledby" | transloco }}
                        <span>
                            <img src="assets/svgs/nbg-logo-black.svg" alt="NBG Logo" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!resultData.isEligible">
        <div class="container pt-[4.5rem] pb-[96px]">
            <div class="flex lg:flex-row flex-col justify-between gap-12">
                <div class="max-w-[700px]">
                    <div class="mb-10">
                        <h3 class="text-black font-bold text-[2.5rem] mb-4">Ας επανεξετάσουμε τα στοιχεία σου</h3>
                        <p>Σύμφωνα με τα στοιχεία που έχεις συμπληρώσει, δεν πληρούνται οι προϋποθέσεις για τη
                            χρηματοδότηση που σε ενδιαφέρει. Μπορείς ωστόσο να εκδηλώσεις ενδιαφέρον από τον παρακάτω
                            σύνδεσμο, έτσι ώστε να σε καλέσουμε για να εξετάσουμε εναλλακτικές δυνατότητες ή να
                            δοκιμάσεις να συμπληρώσεις ξανά τον υπολογιστή στεγαστικού δανείου.</p>
                    </div>
                    @if (propertyId != undefined) {
                        <div class="mb-10">
                            <app-property-card-item [isClickable]="false" [withBorder]="false" [showFavorite]="false" [propertySummary]="propertyCardSummaryData"></app-property-card-item>
                        </div>
                    }
                    <div class="flex flex-wrap gap-6 mb-10">
                        <button class="btn-primary w-full sm:w-auto" (click)="goToLoanApplication()">Εκδήλωσε ενδιαφέρον</button>
                        <button class="btn-secondary justify-center w-full sm:w-auto" (click)="onCalculateAgain()">Υπολόγισε ξανά</button>
                    </div>
                    <section #callback class="mt-8">
                      <app-experts-callback [property]="propertyCardSummaryData" [modalComponent]="'RequestCallbackModalComponent'"></app-experts-callback>
                    </section>
                </div>
                <div>
                    <app-doughnut-chart [showEstimatedFees]="false"></app-doughnut-chart>
                    <div class="my-6 text-gray-700 font-semibold flex flex-row justify-center gap-2 text-xs">
                        {{ "financing.calculator-section.fulfilledby" | transloco }}
                        <span>
                            <img src="assets/svgs/nbg-logo-black.svg" alt="NBG Logo" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        @if (propertyId) {
            <app-navigation-buttons [HideSkip]=" true" [HidePrevious]="false" (PreviousButtonClicked)="onPrevClick()"
            (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
            [CustomPreviousTitle]="t('goBackToPropertyButton')"
            [CustomNextTitle]="t('seeFinanceOptionsButton')"></app-navigation-buttons>
        }
    </ng-container>
</ng-container>
